import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { indexedDBStorage } from './indexedDBStorage'
import { v4 as uuidv4 } from 'uuid'
import { debounce } from 'lodash'

import { createAuthSlice, AuthState } from './slices/authActions'
import { createOrderActionsSlice, OrderActionsState } from './slices/orderActions'
import { createMasterDataSlice, MasterDataState } from './slices/masterdataActions'

type StoreState = AuthState & OrderActionsState & MasterDataState & {
  hasHydrated: boolean;
  setHasHydrated: (stat: boolean) => void;
};

const storeName = 'fhm-stre';

const useStore = create<StoreState>()(
  persist(
    (set, get) => ({
      ...createAuthSlice(set, get),
      ...createOrderActionsSlice(set, get),
      hasHydrated: false,
      setHasHydrated: (stat: boolean) => set({ hasHydrated: stat }),
      ...createMasterDataSlice(set, get),
    }),
    {
      name: storeName,
      storage: createJSONStorage(() => indexedDBStorage(storeName)),
      partialize: (state) => ({
        user: state.user,
        identityToken: (state.identityToken ? state.identityToken : uuidv4()),
        selectedItem: state.selectedItem,
        cart: state.cart,
        orderServeDetails: state.orderServeDetails,
        companyDetails: state.companyDetails,
        categories: state.categories,
        fullCategories: state.fullCategories,
        previousOrders: state.previousOrders,
        deals: state.deals,
        previousDeliveryAddresses: state.previousDeliveryAddresses,
        promoBanners: state.promoBanners,
        showBannerPopup: state.showBannerPopup,
        currentBannerPopup: state.currentBannerPopup,
      }),
      onRehydrateStorage: () => (state) => {
        if (state?.setHasHydrated) {
          state.setHasHydrated(true);
        }
      },
    }
  )
);

// Sync between tabs
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (event) => {
    console.log(event.key, storeName);
    
    if (event.key === storeName) {
      // Force Zustand to rehydrate from IndexedDB when storage changes
      useStore.persist.rehydrate();
    }
  });
}

if (typeof window !== 'undefined') {
  const bc = new BroadcastChannel(storeName + '-sync');

  let isFromBroadcast = false;

  // Listen for messages from other tabs
  bc.onmessage = async (event) => {
    // console.log("yeap");
    
    if (event.data?.type === 'rehydrate') {
      isFromBroadcast = true;
      await useStore.persist.rehydrate();
      isFromBroadcast = false;
    }
  };

  const broadcastUpdate = debounce(() => bc.postMessage({ type: 'rehydrate' }), 100);

  // Watch for local store changes and broadcast updates
  useStore.subscribe(() => {
    if (!isFromBroadcast) {
      broadcastUpdate();
    }
  });
}

export default useStore